export const blogTr = {
  // Blog page
  blogHeroTitle: "SheCan Hikayeleri",
  blogHeroSubtitle: "Gerçek kadınlar. Gerçek güç. Gerçek hikayeler.",
  latestArticles: "Son Yazılar",
  readMore: "Devamını Oku",
  byAuthor: "Yazar:",
  
  // Categories
  empowerment: "Güçlendirme",
  career: "Kariyer",
  wellness: "Sağlık",
  relationships: "İlişkiler",
  personalGrowth: "Kişisel Gelişim",
  inspiration: "İlham",
  mothersWisdom: "Anne'den Öğütler",
  grandmothersLetters: "Ninelerden Mektuplar"
};

export default blogTr;
